import { Box, Tab, Tabs } from '@mui/material';
import { find } from 'lodash';
import { useEffect, useState } from 'react';
import { isDy } from 'src/features/components/editComponentPage/EditComponentPage.helper';
import { useEvent } from 'src/hooks/useEvent';
import { DynamicSectionEvents, DyProductSource } from 'src/interfaces';
import { lang } from 'src/utils';

import { shouldDisplayProductsSourceDropdown } from '../../../modules/productsSourceController/ProductsSourceController.helper';
import { DyTabPanel } from './DyTab';

interface IDyTabs {
  productsSource: DyProductSource;
  panels: {
    default: JSX.Element;
    mobile: JSX.Element;
  };
  handleOnChange: (key: string, value: unknown) => void;
  layoutTypeName?: string;
}

export const DyTabs = ({
  productsSource,
  panels,
  handleOnChange,
  layoutTypeName,
}: IDyTabs) => {
  const [activeTab, setActiveTab] = useState('default');
  const productSourceOptions = [
    { label: lang.singleShelf, value: 'Products' },
    { label: lang.recommended, value: DyProductSource.DYR },
    { label: lang.suggestions, value: DyProductSource.DYS },
  ];

  const { triggerEvent: triggerDySuggestionEvent } = useEvent(
    DynamicSectionEvents.DY_SUGGESTIONS_OPEN,
    {},
  );
  const { triggerEvent: triggerDyRecommendationEvent } = useEvent(
    DynamicSectionEvents.DY_RECOMMENDATIONS_UPDATE,
    {},
  );

  const onTabChange = (isMop: boolean) => {
    if (productsSource === DyProductSource.DYS) {
      triggerDySuggestionEvent({
        isMop,
      });
    } else if (productsSource === DyProductSource.DYR) {
      triggerDyRecommendationEvent({
        isMop,
      });
    }
  };

  const tabs: {
    value: 'default' | 'mobile';
    label: string;
    disabled: boolean;
  }[] = [
    {
      value: 'default',
      label:
        find(productSourceOptions, { value: productsSource })?.label ??
        lang.singleShelf,
      disabled: false,
    },
    {
      value: 'mobile',
      label: lang.mobileUser,
      disabled: !isDy(productsSource),
    },
  ];

  useEffect(() => {
    // reset the state after the gcf cod rerender
    setTimeout(() => {
      setActiveTab('default');
    }, 0);

    if (
      productsSource !== DyProductSource.DYS &&
      productsSource !== DyProductSource.DYR
    ) {
      handleOnChange('mop', undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsSource]);

  return shouldDisplayProductsSourceDropdown(layoutTypeName) ? (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => {
            setActiveTab(value);
            onTabChange(value === 'mobile');
          }}>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              value={tab.value}
              label={tab.label}
              sx={{ width: '50%', textTransform: 'none', fontSize: '1rem' }}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, index) => (
        <DyTabPanel key={index} tabValue={tab.value} activeTab={activeTab}>
          {panels?.[tab.value]}
        </DyTabPanel>
      ))}
    </Box>
  ) : (
    panels.default
  );
};
